__webpack_require__.p = "https://prana-club.com/app-static/app-production-b2cf939f4f60-1/_next/";